<template>
  <Modal v-model="model"  sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide :mask="false" draggable class="manual_out_call">
    <div class="manual_call_left">
      <div class="font_style_set"><span class="span_must">*</span>号码:</div>
      <Input  v-model="rosternumber" class="config_content"  clearable style="width: 250px"/>
    </div>
    <div class="manual_call_right">
      <div class="font_style_set">匹配方式:</div>
      <RadioGroup v-model="matching" type="button" style="width: 250px">
        <Radio v-for="(option, index) in matchingList" :label="option.id" :key="index">{{option.name}}</Radio>
      </RadioGroup>
    </div>
    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="save()">保存</Button>
    </div>
  </Modal>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
      name: "NameListPop",
      mixins:[publicFunClass],
      props: {
        showNameList:Boolean,
        callId:String,
        calltel:String,
        callmatype:String,
        tabslisttype:String,
        dpid:String,
      },
      data(){
        return {
          model:false,
          matching:"1",
          matchingList:[{'id':'1','name':'后缀匹配'},{'id':'0','name':'精确匹配'}],
          rosternumber:'',
          title:'',
          journalType:'',
          menuId:'',
          managelist:[],
        }
      },
      methods:{
        cancel:function(){
          this.$emit("closeNameListPop",false);
        },
        save:function(){
          let that=this;
          if(!this.rosternumber){
            that.$Modal.info({
              title:'提示',
              content:"号码不能为空"
            });
            return false;
          }
          if(!this.matching){
            that.$Modal.info({
              title:'提示',
              content:"请选择匹配方式"
            });
            return false;
          }
          let param= {
            callType:"2",//呼出
            matchOp:this.matching,//匹配方式
            telphone:this.rosternumber,//号码
            dpid:this.dpid,//黑或白名单
            id:this.callId,
            journalType:this.journalType,
            menuId:this.menuId
           // tabslisttype:this.tabslisttype,

          }
          this.$http.post("blackWhiteList/doSave.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.$Message.info("操作成功");
            that.$emit("closeNameListPop",true);
          });
        },
        initSearch:function () {
          if(this.callId){
            this.rosternumber=this.calltel;
            this.matching=this.callmatype;
          }else{
            this.rosternumber="";
            this.matching="1";
          }
        },
      },
      watch:{
        showNameList:function () {
          this.model=this.showNameList;
          if(this.showNameList){
            let param = "黑白名单";
            if(!this.callId){//添加
              if(this.tabslisttype=="1"){
                this.title='添加黑名单';
                param = "黑名单";
              }else if(this.tabslisttype=="2"){
                this.title='添加白名单';
                param = "白名单";
              }
              this.journalType="系统管理=>"+param+"=>添加";
              this.menuId="3_11-1";
            }else{//编辑
              if(this.tabslisttype=="1"){
                this.title='编辑黑名单';
                param = "黑名单";
              }else if(this.tabslisttype=="2"){
                this.title='编辑白名单';
                param = "白名单";
              }
              this.journalType="系统管理=>"+param+"=>编辑";
              this.menuId="3_11-7";
            }
            this.initSearch();
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/NameListPop.vue